//import libraries
import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth,
  addHours,
} from 'date-fns';
import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarView,
} from 'angular-calendar';
import { Subject } from 'rxjs';
import { DashboardService } from "../../../services/dashboard.service";
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CalendarAddEditEventComponent } from './calendar-add-edit-event/calendar-add-edit-event.component'
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationDialogService } from '../../general/modals/confirmation/confirmation.service';
declare var $: any;

const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
};

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css']
})
export class CalendarComponent implements OnInit {
  @ViewChild('modalContent') modalContent: TemplateRef<any>;
  view: CalendarView = CalendarView.Month;
  modalRef?: BsModalRef;
  CalendarView = CalendarView;

  viewDate: Date = new Date();

  modalData: {
    action: string;
    event: CalendarEvent;
  };

  createForm: FormGroup;
  createFormSubmitted: Boolean = false;
  createFormErrorMsg: any;
  actions: CalendarEventAction[] = [
    {
      label: '<i class="fas fa-fw fa-pencil-alt"></i>',
      a11yLabel: 'Edit',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.handleEvent('Edited', event);
      },
    },
    {
      label: '<i class="fas fa-fw fa-trash-alt"></i>',
      a11yLabel: 'Delete',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter((iEvent) => iEvent !== event);
        this.handleEvent('Deleted', event);
      },
    },
  ];

  refresh = new Subject<void>();

  events: CalendarEvent[] = [];

  activeDayIsOpen: boolean = true;
  lang: any;
  locale: string;
  addEditModal: BsModalRef;
  constructor(
    private dashboardService: DashboardService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder, 
    private confirmationDialogService: ConfirmationDialogService,
  ) { }
  

  ngOnInit() {
    let defaultLang = localStorage.getItem("lang")
    if(defaultLang == "english") defaultLang = "en"
    else if(defaultLang == "italian") defaultLang = "it"
    else defaultLang = "en"
    
    this.locale = defaultLang
    
    this.dashboardService.calendar_data()
      .subscribe(
        (res) => {

          // console.log('test'); return false;

          this.lang   = this.dashboardService.calendarLang(res);
        
          let details = res.calendar;
          let that = this;
          if(details){
            details.forEach(element => {

              that.events.push(
                {
                  start: new Date(element.start.replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")),
                  end: new Date(element.end.replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")),
                  title: element.title,
                  meta: {
                    title : element.title,
                    module : element.module,
                    type : element.type,
                  },
                  color: colors.red,
                },
              );
          });
          }

          
          console.log('===== Calendar =========');
          console.log(that.events)

        }
      );
  }

  onSubmit(){
    this.createFormSubmitted = true;
  }

  FormBuild(): void {

    this.createForm = this.formBuilder.group({
      event: ['', [Validators.required]],
      start_date: ['', [Validators.required]],
      end_date: ['', [Validators.required]],

    });

  }  

  formErrorClass(value, submitted): string {
    return value.errors && (value.touched || value.dirty || submitted) ? 'error-border' : '';
  }  

  addEditEvent(template: TemplateRef<any>) {
    this.FormBuild()
    // this.addEditModal = this.modalService.show(CalendarAddEditEventComponent, { initialState: {'ID': '','langs': this.lang} });
    this.modalRef = this.modalService.show(template);
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });
    this.handleEvent('Dropped or resized', event);
  }

  handleEvent(action: string, event: CalendarEvent): void {
    this.modalData = { event, action };
    // this.modal.open(this.modalContent, { size: 'lg' });
  }

  addEvent(): void {
    this.events = [
      ...this.events,
      {
        title: 'New event',
        start: startOfDay(new Date()),
        end: endOfDay(new Date()),
        color: colors.red,
        draggable: true,
        resizable: {
          beforeStart: true,
          afterEnd: true,
        },
      },
    ];
  }

  deleteEvent(eventToDelete: CalendarEvent) {
    console.log("====== Event ========")
    console.log(eventToDelete)
    
    this.confirmationDialogService.confirm('Delete Confirmation', 'Are you sure to delete?')
        .subscribe(
          (confirmed) => {
            
            if (!confirmed) return;
            else{
              this.events = this.events.filter((event) => event !== eventToDelete);
            }

            // this.deadlineService.delete(ID)
            //   .subscribe(
            //     (res) => {
            //       if (res.status)
            //         this.success(res.msg);
            //       else
            //         this.error(res.msg);
            //   });

    });    
    
  }

  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }


}
